import React from 'react';
import { object, string, number } from 'yup';

import { env } from '~/commons/config';

import FormResource from './FormResource.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';

const schema = object().shape({
  district: string().required(),
  stage: string().required(),
  studentCount: number().required().min(0).integer(),
});
const defaults = {
  title: {
    en: '',
    zhhk: '',
  },
  district: '',
  stage: '',
  studentCount: 0,
};

const FormSchool = ({
  school,
  onSubmit,
}) => (
  <FormResource
    {...{
      defaults,
      schema,
      stored: school,
      api: 'api/core/schools',
      onSubmit,
    }}
  >
    <FormGroup name="title.en" label="Name" />
    <FormGroup name="title.zhhk" label="Name (Chinese)" />
    <FormGroup name="studentCount" type="number" />
    <div className="form-row">
      <div className="col">
        <FormGroup name="district" as="select">
          <option value=""> - </option>
          {Object.keys(env.districts).map((key) => (
            <option key={key} value={key}>
              {env.districts[key].zhhk}
            </option>
          ))}
        </FormGroup>
      </div>
      <div className="col">
        <FormGroup name="stage" as="select">
          <option value=""> - </option>
          <option value="p">小學</option>
          <option value="s">中學</option>
        </FormGroup>
      </div>
    </div>
  </FormResource>
);

export default FormSchool;
